module.exports = __webpack_public_path__ + "static/media/03A.6fcfbd9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/robots/03A.png
// module id = 251
// module chunks = 0